import { queryBuilder } from '../utils/dxf';

export const fetchExternalSchemaQuery = queryBuilder({
  fields: {
    dxSchema: true
  }
});
